import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

function PINReset() {
  const [oldPin, setOldPin] = useState('');
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [loading, setLoading] = useState(false);
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();

    if (newPin !== confirmPin) {
      toast.error('New PIN and Confirm PIN do not match');
      return;
    }

    if (newPin.length !== 6) {
      toast.error('PIN must be 6 digits');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/auth/reset-pin`, {
        old_pin: oldPin,
        new_pin: newPin
      });
      
      toast.success('PIN reset successful. Please login again.');
      logout();
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'PIN reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <Card className="w-full max-w-md p-8 border border-border">
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 bg-warning rounded-md flex items-center justify-center">
            <Lock className="w-10 h-10 text-white" />
          </div>
        </div>

        <h2 className="text-3xl font-heading font-bold text-center mb-2" data-testid="pin-reset-heading">Reset Your PIN</h2>
        <p className="text-muted text-center mb-8">
          For security reasons, please change your temporary PIN
        </p>

        <form onSubmit={handleReset} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2">Current PIN</label>
            <Input
              data-testid="old-pin-input"
              type="password"
              placeholder="Enter current PIN"
              value={oldPin}
              onChange={(e) => setOldPin(e.target.value)}
              maxLength={6}
              required
              className="h-11"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">New PIN</label>
            <Input
              data-testid="new-pin-input"
              type="password"
              placeholder="Enter new 6-digit PIN"
              value={newPin}
              onChange={(e) => setNewPin(e.target.value)}
              maxLength={6}
              required
              className="h-11"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Confirm New PIN</label>
            <Input
              data-testid="confirm-pin-input"
              type="password"
              placeholder="Re-enter new PIN"
              value={confirmPin}
              onChange={(e) => setConfirmPin(e.target.value)}
              maxLength={6}
              required
              className="h-11"
            />
          </div>

          <Button 
            data-testid="pin-reset-submit-button"
            type="submit" 
            className="w-full h-11" 
            disabled={loading}
          >
            {loading ? 'Resetting...' : 'Reset PIN'}
          </Button>
        </form>
      </Card>
    </div>
  );
}

export default PINReset;